module.exports = __webpack_public_path__ + "img/four-full-star.343733c2.svg";